import { Icon, IconProps } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useCatalystInsightDetails } from '~/hooks/use-catalyst-insights/useCatalystInsights';

import * as S from './CatalystInsightTooltip.styles';

interface CatalystInsightTooltipProps {
  insightId: string;
  iconProps: IconProps;
}

export const CatalystInsightTooltip = ({
  insightId,
  iconProps,
}: CatalystInsightTooltipProps) => {
  const { t } = useTranslation(['insights']);
  const { data, isLoading } = useCatalystInsightDetails(insightId);
  return (
    <S.TooltipWrapper>
      <Icon {...iconProps} size={32} />
      <S.RightWrapper>
        <S.TitleLabel>{t('insights:catalyst.title')}</S.TitleLabel>
        <S.CategoryLabel>
          {isLoading ? (
            <S.StyledLoader />
          ) : data?.sub_category ? (
            /* i18next-extract-mark-context-next-line ["financial_operational_updates", "corporate_actions_strategic_announcements", "management_leadership_changes", "legal_regulatory_events"] */
            t(`catalyst.subcategories.${data.sub_category}`)
          ) : null}
        </S.CategoryLabel>
      </S.RightWrapper>
    </S.TooltipWrapper>
  );
};
